import { FC, PropsWithChildren } from "react";
import { DatePicker, DatePickerRootProps, Portal } from "@chakra-ui/react";
import { CalendarIcon } from "lucide-react";
import { formatDate, parseDateInput } from "./utils";

type Props = DatePickerRootProps & {
  label: string;
};

const DSDatePicker: FC<PropsWithChildren<Props>> = ({
  value,
  label,
  children,
  onValueChange,
  ...props
}) => (
  <DatePicker.Root
    locale="en-GB"
    {...props}
    format={formatDate}
    parse={parseDateInput}
    value={value}
    onValueChange={onValueChange}
  >
    <DatePicker.Label fontSize="inherit">{label}</DatePicker.Label>

    <DatePicker.Control>
      <DatePicker.Input index={0} />
      {props.selectionMode === "range" && <DatePicker.Input index={1} />}

      <DatePicker.IndicatorGroup>
        <DatePicker.Trigger>
          <CalendarIcon />
        </DatePicker.Trigger>
      </DatePicker.IndicatorGroup>
    </DatePicker.Control>

    <Portal>
      <DatePicker.Positioner>
        <DatePicker.Content w="min-content">
          <DatePicker.View view="day">
            <DatePicker.Header />
            {children}
            <DatePicker.DayTable
              // always reserve enough height for max days in a month to avoid
              // bad UX due to calendar height changing
              minHeight={280}
            />
          </DatePicker.View>

          <DatePicker.View view="month">
            <DatePicker.Header />
            {children}
            <DatePicker.MonthTable />
          </DatePicker.View>

          <DatePicker.View view="year">
            <DatePicker.Header />
            {children}
            <DatePicker.YearTable />
          </DatePicker.View>
        </DatePicker.Content>
      </DatePicker.Positioner>
    </Portal>
  </DatePicker.Root>
);

export default DSDatePicker;
